import { render, staticRenderFns } from "./WelcomeBox.vue?vue&type=template&id=1c0e4fa2&scoped=true&"
import script from "./WelcomeBox.vue?vue&type=script&lang=js&"
export * from "./WelcomeBox.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBox.vue?vue&type=style&index=0&id=1c0e4fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e4fa2",
  null
  
)

export default component.exports